import React, { Component } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { NavigateFunction, useParams, useNavigate } from 'react-router-dom'
import { deleteTrack } from '@disco/state-management/actions/ServerActions'
import { getTrack } from '@disco/state-management/selectors/tracks'
import DocumentHeadTags from 'components/document-head-tags'
import DeleteTrackModal from 'components/modals/track/delete'
import type { State } from 'types/redux'
import type { RootState } from 'store/configureStore'
interface OwnProps {
  params: {
    trackId: string
  }
  navigate: NavigateFunction
}

function mapStateToProps(state: RootState, props: OwnProps) {
  return {
    track: getTrack(state, {
      id: parseInt(props.params.trackId, 10),
    }),
  }
}

const mapDispatchToProps = {
  deleteTrack,
}

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>
type DeleteTrackProps = PropsFromRedux & OwnProps

class DeleteTrack extends Component<DeleteTrackProps> {
  _onClose = () => this.props.navigate('/')

  render() {
    return (
      <div>
        <DocumentHeadTags title="Delete track | DISCO" />
        <DeleteTrackModal
          track={this.props.track}
          onClose={this._onClose}
          deleteTrack={this.props.deleteTrack}
        />
      </div>
    )
  }
}

const ConnectedDeleteTrack = connector(DeleteTrack)

// Wrapper component to provide router params and navigation to the connected component
const DeleteTrackWithRouter = (props: any) => {
  const params = useParams<{ trackId: string }>()
  const navigate = useNavigate()

  return <ConnectedDeleteTrack {...props} params={params} navigate={navigate} />
}

export default DeleteTrackWithRouter
